import styled from 'styled-components'

import theme from '../../theme'

const styleString = `
display: flex;
flex-flow: row wrap;
align-content:center;
height: 22px;
width: fit-content;
border-radius: 2px;
background-color: ${theme.colors.brandPrimary1};
border: 1px solid ${theme.colors.brandPrimary3};
color: ${theme.colors.brandPrimary6};
font-weight: ${theme.fontWeights.semiBold};
font-size: ${theme.fontSizes.small};
line-height: 22px;
text-align: center;
padding: 0px 8px;
`

const TagDiv = styled.div`
  ${styleString}
`
const TagSpan = styled.span`
  ${styleString}
`

export { TagDiv, TagSpan }
